<template>
  <div class="tinymce-editor">
    <editor v-model="myValue" @input="onInput" :init="init"></editor>
  </div>
</template>

<script>
import { publicUpload } from "../api/coment";
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver/theme";
import "tinymce/icons/default/icons";
import "tinymce/plugins/image"; //图片
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/table"; //表格
import "tinymce/plugins/lists"; //列表
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount"; //字数统计
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/media"; // 插入视频插件

export default {
  components: {
    Editor,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      //初始化配置
      init: {
        language_url: "/static/tinymce/langs/zh_CN.js", //语言包的路径
        language: "zh_CN",
        skin_url: "/static/tinymce/skins/ui/oxide",
        height: 600,
        fontsize_formats: "8px 10px 12px 14px 16px 18px 24px 36px",
        statusbar: false,
        plugins:
          "link lists image  code table colorpicker textcolor wordcount contextmenu media  ",
        toolbar:
          "bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image code | removeformat",
        branding: false,
        //自定义图片上传
        images_upload_handler: (blobInfo, success, failure) => {
          let formData = new FormData();
          formData.append("file", blobInfo.blob(), blobInfo.filename());
          //上传图片
          publicUpload(formData).then((response) => {
            success(response.url);
          });
        },

      },
      myValue: this.value,
    };
  },
  mounted() {
    tinymce.init({});
  },
  methods: {
    //添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    //需要什么事件可以自己增加
    onClick(e) {
      this.$emit("onClick", e, tinymce);
    },
    onInput() {
      this.$emit("input", this.myValue);
    },


  },
  watch: {
    value(newValue) {
      this.myValue = newValue;
    },
    myValue(newValue) {
      this.$emit("input", newValue);
    },
  },
  beforeDestroy() {},
};
</script>

<style>

.image-upload-panel {
  overflow: hidden;
}
.image-upload-btn {
  float: left;
  width: 150px;
  height: 150px;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  line-height: 150px;
  text-align: center;
}

.image-upload-btn div {
  width: 150px;
}

.image-upload-btn i {
  font-size: 30px;
  font-weight: 400;
}
.image-item {
  float: left;
  width: 150px;
  height: 150px;
  background: #ddd;
  margin-right: 10px;
  border-radius: 6px;
  position: relative;
}
.image-item img {
  max-width: 150px;
  border-radius: 6px;
}
.image-del {
  position: absolute;
  top: 0px;
  right: 0px;
  color: red;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/common/tinymceEditor.vue